import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import BottomModal from '../../../components/modal/bottomModal';
import { useBackPress } from '../../../hooks/useBackPress';
import { useCurrency } from '../../../hooks/useCurrency';
import TipsCard from './tipsCard';
import TipsCustomInput from './tipsCustomInput';
import TipsWaiterDropdown from './tipsWaiterDropdown';

const tipsPercents = [10, 20];
const tipsFixed = [2, 5, 10];

const CheckoutTips = ({
  bill,
  onChange,
  onChangeEmployee,
  useFixed,
  employees,
  allowWaiterSelect,
  preventSelectAllTeam,
  fromTipsCheckout,
}) => {
  const { t } = useTranslation();

  const { currencySymbol } = useCurrency();

  const [tipsAmount, setTipsAmount] = useState(0);
  const [selectedTips, setSelectedTips] = useState(0);
  const [customTipsOpen, setCustomTipsOpen] = useState(false);

  const { handleBackOnModalOpen, handleBackOnModalClose } = useBackPress(
    fromTipsCheckout ? '/checkout-tips' : '/checkout',
    () => {
      setCustomTipsOpen(false);
    },
  );

  return (
    <>
      <TipsWaiterDropdown
        allowWaiterSelect={allowWaiterSelect}
        preventSelectAllTeam={preventSelectAllTeam}
        employees={employees}
        fromTipsCheckout={fromTipsCheckout}
        onSelect={(val) => onChangeEmployee(val)}
        tipsAmount={tipsAmount}
      />
      <div className="mt-5 flex flex-wrap">
        {!useFixed &&
          tipsPercents.map((percent) => {
            const tipsSize = bill.subtotal * (percent / 100);
            return (
              <div key={percent} className="mr-3 mb-3">
                <TipsCard
                  selected={selectedTips === percent}
                  onSelect={(newSelected) => {
                    if (newSelected) {
                      setSelectedTips(percent);
                      setTipsAmount(tipsSize);
                      onChange(tipsSize);
                    } else {
                      setSelectedTips(0);
                      setTipsAmount(0);
                      onChange(0);
                    }
                  }}
                  percent={percent}
                  amount={tipsSize}
                  currency={currencySymbol}
                />
              </div>
            );
          })}
        {useFixed &&
          tipsFixed.map((price) => {
            return (
              <div key={price} className="mr-3 mb-3">
                <TipsCard
                  selected={selectedTips === price}
                  onSelect={(newSelected) => {
                    if (newSelected) {
                      setSelectedTips(price);
                      setTipsAmount(price);
                      onChange(price);
                    } else {
                      setSelectedTips(0);
                      setTipsAmount(0);
                      onChange(0);
                    }
                  }}
                  amount={price}
                  currency={currencySymbol}
                  isFixed
                />
              </div>
            );
          })}
        <div className="mb-3">
          <TipsCard
            selected={selectedTips === 'Custom'}
            onSelect={() => {
              setCustomTipsOpen(true);
              handleBackOnModalOpen();
            }}
            isCustom
          />
        </div>
        <BottomModal
          title={t('checkout.customTipsTitle')}
          content={
            <TipsCustomInput
              onConfirm={(val) => {
                if (val) {
                  setSelectedTips('Custom');
                  setTipsAmount(val);
                  onChange(val);
                } else {
                  setSelectedTips(0);
                  setTipsAmount(0);
                  onChange(0);
                }
                setCustomTipsOpen(false);
                handleBackOnModalClose();
              }}
            />
          }
          onClose={() => {
            setCustomTipsOpen(false);
            handleBackOnModalClose();
          }}
          onOutClick={() => {
            setCustomTipsOpen(false);
            handleBackOnModalClose();
          }}
          open={customTipsOpen}
        />
      </div>
    </>
  );
};

export default CheckoutTips;
